// Иконка Шифроконтейнера (4 типа: main_common / main_faction /
// advanced_common / advanced_faction). Маппит тип из БД на SVG-файл
// в /img/ui/containers/. На неизвестных типах возвращает иконку
// «main_common» как дефолт.
//
// Использование:
//   <ContainerIcon type="advanced_faction" size={20} />

interface Props {
  type: string;            // e.g. 'main_common'
  size?: number;
  className?: string;
  style?: React.CSSProperties;
  title?: string;          // tooltip
}

const TYPE_LABEL: Record<string, string> = {
  main_common: 'Основной общий ШК',
  main_faction: 'Основной фракционный ШК',
  advanced_common: 'Продвинутый общий ШК',
  advanced_faction: 'Продвинутый фракционный ШК',
  // Совместимость со старыми обозначениями.
  basic_common: 'Основной общий ШК',
  basic_faction: 'Основной фракционный ШК'
};

function resolveSrc(type: string): string {
  if (type === 'advanced_faction') return '/img/ui/containers/advanced_faction.svg';
  if (type === 'advanced_common')  return '/img/ui/containers/advanced_common.svg';
  if (type === 'main_faction' || type === 'basic_faction') return '/img/ui/containers/main_faction.svg';
  // main_common / basic_common / неизвестное → main_common.
  return '/img/ui/containers/main_common.svg';
}

export function ContainerIcon({ type, size = 18, className, style, title }: Props) {
  const label = title || TYPE_LABEL[type] || `ШК ${type}`;
  return (
    <img
      src={resolveSrc(type)}
      alt={label}
      title={label}
      width={size}
      height={size}
      className={className}
      style={{
        display: 'inline-block',
        verticalAlign: 'middle',
        flexShrink: 0,
        ...style
      }}
    />
  );
}
